/** The reason a person is shown when their account is suspended (spec architecture/BE/account-cutoff.md, "Reason codes").
 *  ONE list for the whole console; the exact code strings are the contract with tezda-live. The moderator's own note stays internal. */
export const ACCOUNT_REASONS=[
  {code:'sexual_content',label:'Sexual content or nudity'},
  {code:'violence',label:'Violence or dangerous acts'},
  {code:'hate_harassment',label:'Hate speech or harassment'},
  {code:'scam_fraud',label:'Scams, fraud or payment abuse'},
  {code:'spam_fake',label:'Spam or fake accounts'},
  {code:'child_safety',label:'Child safety'},
  {code:'ban_evasion',label:'Creating a new account after a ban'},
  {code:'community_guidelines',label:'Breaking our Community Guidelines'},
] as const;
export type AccountReasonCode=typeof ACCOUNT_REASONS[number]['code'];
export const DEFAULT_BULK_REASON:AccountReasonCode='sexual_content';
export const DEFAULT_REASON:AccountReasonCode='community_guidelines';

export const NOT_MODERATOR='You are not on the moderator list. Nothing was changed.';
/** Text for a refused moderator call: a real 403 means the moderator list, otherwise the server's own words. */
export const refusalText=(status:number,message:string|undefined,fallback:string)=>status===403?NOT_MODERATOR:message||fallback;
/** Words for a refused account action. The server's own text wins; a 403 means the moderator list, a 409 means nothing to do. */
export function accountActionError(e:any):string{
  const status=e?.status;
  if(status===403)return NOT_MODERATOR;
  return e?.message||'That did not go through. Nothing was changed.';
}
export const reasonLabel=(code:string)=>ACCOUNT_REASONS.find(r=>r.code===code)?.label??code;
/** One line under every reason select. Only the newest app versions show it, so it promises no more. */
export const REASON_SHOWN_NOTE='Shown to the person in the app (newest versions).';
